import { motion, useReducedMotion, useScroll, useSpring } from "framer-motion";

// Thin gradient bar fixed to the top of the viewport that tracks reading
// progress through the page. Spring-smoothed so it glides on both desktop
// and touch scrolling.
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });
  const reduced = useReducedMotion();

  if (reduced) return null;

  return (
    <motion.div
      aria-hidden
      className="fixed top-0 left-0 right-0 h-[3px] z-[60] origin-left bg-gradient-to-r from-primary via-accent to-primary pointer-events-none"
      style={{ scaleX }}
    />
  );
}
